

























































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { namespace, State } from 'vuex-class';
import { Mall, Mds, GetDeliveryTemplate } from 'supporter';
import { Admin } from '@/types';
import { Grid } from '@toast-ui/vue-grid';
import TuiGrid from 'tui-grid';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import { saveAs } from 'file-saver';
import { ncpPopup } from '@/utils/ncp';
import ClickOutside from 'vue-click-outside';
import store from '@/store';
import {
  escapeHtml,
  getCurrency,
  centerWinOptions,
  productNameConvertor,
  getProductsConfigurationsByAllMall,
} from '@/utils/commonUtils';
import { ProductNameEditor } from '@/components/product/ProductListGridClass';
import { getToday } from '@/utils/dateUtils';
import { toI18n } from '@/utils/commonUtils';
const mallModule = namespace('mall');
const adminModule = namespace('admin');
window.addEventListener(
  'message',
  function(event: any) {
    if (event.data.templateNo) {
      store.commit('delivery/SET_DELIVERY_TEMPLATE_NO', event.data.templateNo);
    }
    if (event.data.uploadedImages) {
      event.data.uploadedImages.forEach(uploadedImage => {
        store.commit('product/SET_EXTERNAL_URL_YN', 'N');
        store.commit('product/PUT_HAS_SUCCESS_IMAGE', uploadedImage);
      });
    }
    if (event.data.externalUrlYn) {
      store.commit('product/SET_EXTERNAL_URL_YN', event.data.externalUrlYn);
    }
  },
  false,
);
@Component({
  components: { CompSelectBox },
  directives: {
    ClickOutside,
  },
})
export default class ProductAddBulk extends Vue {
  @State('deliveryTemplateNo', { namespace: 'delivery' }) private stateDeliveryTemplateNo!: number;
  @State('uploadedImages', { namespace: 'product' }) private uploadedImages!: string[];
  @State('externalUrlYn', { namespace: 'product' }) private externalUrlYn!: string;

  private admins: Mds[] = [];
  private products: any[] = [];
  private productNos: number[] = [];
  @adminModule.Getter('admin') private stateAdmin!: Admin;
  private displayAdmins: any[] = [];
  private errorCommissionRate: boolean = false;
  private partner = {
    commissionRate: 0,
  };
  private layerPop = false;
  private uploadedResult = {
    failCount: 0,
    seq: 0,
    successCount: 0,
  };
  private product: any = {
    excelFile: null,
    mallNo: undefined,
    adminNo: 0,
    productCommissionType: 'PRODUCT',
    commissionRate: '',
    shippingAreaType: 'PARTNER_SHIPPING_AREA',
    deliveryTemplateNo: '',
  };
  private admin = {
    adminName: '',
  };
  @mallModule.State('malls') private malls!: Mall[];
  public pDI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_PRODUCTLIST_' + needToI18nStr));
  }
  private deliveryTemplates: GetDeliveryTemplate[] = [];
  private partnerDeliveryTemplates: GetDeliveryTemplate[] = [];
  private shoppingMalldeliveryTemplates: GetDeliveryTemplate[] = [];
  private shippingAreaPartnerNo = 0;
  private isMallToolTip = false;

  private get mallData() {
    return this.malls.map(mall => ({ mallNo: mall.mallNo, mallName: mall.mallName, disable: mall.planType === 'PRO' }));
  }

  private gridProps = {
    columns: [
      {
        header: this.pDI18n('PLD_MODIFY'),
        name: 'modifyBtn',
        minWidth: 50,
        align: 'center',
        formatter: ({ row }: any): string => {
          let text = this.pDI18n('PLD_MODIFY'); //
          return `<a href="/product/edit/${row.mallProductNo}?planType=${row.mallServicePlan}" target="_blank">${text}</a>`;
        },
      },
      {
        header: this.pDI18n('PLD_COPY'),
        name: 'copyBtn',
        minWidth: 50,
        align: 'center',
        formatter: ({ row }: any): string => {
          if (row.optionType === 'MAPPING') {
            return '-';
          }
          if (row.parentMallProductNo === 0) {
            // ???itemYn Which prop is in the new api(GET /products/search), now unclear~~~
            // const planType = row.mallS
            const url = `/product/popup/copyMallProduct?mallNo=${row.mallNo}&mallProductNo=${
              row.mallProductNo
            }&saleStatusType=${row.saleStatusType}&itemYn=${row.isItem ? 'Y' : 'N'}&planType=${row.mallServicePlan}`;
            const txt = this.pDI18n('PLD_COPY');
            return `<a href="javascript:onclick=window.open('${url}','copyMallProductWin','${centerWinOptions(
              888,
              610,
            )}')">${txt}</a>`;
          }

          return '';
        },
      },
      {
        header: this.pDI18n('PLD_SHOPPING_MALL'),
        name: 'mallName',
        minWidth: 100,
        align: 'center',
      },
      {
        header: this.pDI18n('PLD_PRODUCT_NUMBER'),
        name: 'mallProductNo',
        minWidth: 90,
        align: 'center',
        formatter: this.getProductDetailUrl,
      },
      {
        header: this.pDI18n('PLD_PRODUCT_NAME'),
        name: 'productName',
        minWidth: 200,
        align: 'left',
        onAfterChange: this.productNameOnChange,
        editor: {
          type: ProductNameEditor,
        },
        formatter: ({ value, row }: any): string => {
          return productNameConvertor(value, row);
        },
      },
      {
        header: this.pDI18n('PLD_BRAND'),
        name: 'brandName',
        minWidth: 120,
        align: 'left',
        formatter: ({ value }: any): string => {
          return escapeHtml(value);
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_MANAGER'),
        name: 'adminName',
        align: 'center',
      },
      {
        header: this.pDI18n('PLD_COMMISSION'),
        name: 'commissionRate',
        align: 'center',
        formatter: ({ row }: any): string => {
          if (row.saleMethodType === 'PURCHASE' || row.commission.type === 'PURCHASE_PRICE') {
            return '-';
          }

          return `${row.commission.rate}%`;
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_SALES_PERIOD'),
        name: 'salePeriod',
        minWidth: 250,
        align: 'center',
        formatter: ({ value }: any): string => {
          if (value && value.startYmdt && value.endYmdt) {
            return `${value.startYmdt} ~ ${value.endYmdt}`;
          } else {
            return '-';
          }
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_PRICE'),
        name: 'salePrice',
        align: 'right',
        formatter: ({ value, row }: any): string => {
          // return getCurrency(value, this.USMallNos.includes(row.mallNo));
          return getCurrency(value);
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_IMMEDIATE_DISCOUNT'),
        // name: 'immediateDiscountValue',
        name: 'immediateDiscountInfo',
        align: 'right',
        formatter: ({ value, row }: any): string => {
          // return getCurrency(value.amount, this.USMallNos.includes(row.mallNo));
          return getCurrency(value.amount);
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_DISCOUNT_APPLICABLE_PRICE'),
        // name: 'discountApplyPrice',
        name: 'appliedImmediateDiscountPrice',
        align: 'right',
        formatter: ({ value, row }: any): string => {
          const val = getCurrency(value, row.countryCd === 'US');
          if (parseInt(val, 10) <= 0) {
            return '0';
          }
          return val;
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_INVENTORY_QUANTITY_SALEABLE_INVENTORY'),
        name: 'stockCnt',
        minWidth: 100,
        align: 'right',
        editOptions: { type: 'text', useViewMode: true },
        formatter({ value, row, column }) {
          const totalCnt = row.productStock.totalCnt;
          if (totalCnt) {
            return totalCnt;
          } else {
            return this.pDI18n('SOLD_OUT');
          }
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_SALES_QUANTITY'),
        name: 'saleCnt',
        align: 'right',
        formatter: ({ row }: any): string => {
          return row.productStock.totalSaleCnt;
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_OPTION'),
        name: 'optionBtn',
        minWidth: 50,
        align: 'center',
        formatter: ({ row }: any): string => {
          if (!row.hasOption) {
            return this.pDI18n('PLD_NOT_USE');
          }

          let text = this.pDI18n('PLD_EXAMPLE'); //

          const {
            mallProductNo,
            saleMethodType,
            saleStatusType,
            mallNo,
            salePrice,
            countryCd,
            optionType,
            partnerNo,
            deliveryTemplateNo,
            hasOption,
            appliedImmediateDiscountPrice,
          } = row;
          const params = {
            mallProductNo,
            saleMethodType,
            saleStatusType,
            mallNo,
            salePrice,
            countryCd,
            optionType,
            partnerNo,
            deliveryTemplateNo,
            hasOption,
            appliedImmediateDiscountPrice,
            commissionRate: row.commission.rate,
            commissionRateType: row.commission.type,
            isDirectSave: true,
            readonly: true,
          };
          return `<a href="javascript:onclick=window.open('/option/addForm?${$.param(
            params,
          )}','deliveryWaitingStockCntWin','${centerWinOptions(1222, 711)}');" class="gridModifyOption">${text}</a>`;
        },
      },
      {
        header: this.pDI18n('PLD_ADDITIONAL_PRODUCTS'),
        name: 'additionalProductBtn',
        minWidth: 70,
        align: 'center',
        formatter: ({ row }: any): string => {
          return '-';
        },
      },
      {
        header: this.pDI18n('PLD_APPLY_PROMOTION'),
        name: 'canPromotion',
        minWidth: 100,
        align: 'center',
        formatter: ({ value, row }: any): string => {
          const currentValue = value ? 'Y' : 'N';

          return currentValue;
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_PRODUCT_INFORMATION_NOTICE'),
        name: 'productDuty',
        minWidth: 100,
        align: 'center',
        formatter: ({ row }: any): string => {
          const text = this.pDI18n('PLD_EXAMPLE'); //

          return `<a href="javascript:onclick=window.open('${'/productDuty/readForm?mallProductNo=' +
            row.mallProductNo}','productDutyWin','${centerWinOptions(1085, 830)}')">${text}</a>`;
        },
      },
      {
        header: this.pDI18n('PLD_REGISTER_PRICE_COMPARISON_SITE'),
        name: 'priceComparisonSite',
        minWidth: 110,
        align: 'center',
        formatter: ({ value: { check }, row }: any): string => {
          const siteYn = check === 'NONE' ? 'N' : 'Y';

          return siteYn;
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_EXHIBITION_CATEGORY'),
        name: 'displayCategoryNames',
        minWidth: 250,
        align: 'left',
        formatter: ({ value, row }: any): any => {
          if (!value[0]) {
            return null;
          }
          const url = `/product/popup/displayCategoryInfo?mallProductNo=${row.mallProductNo}`;
          return `<a href="javascript:onclick=window.open('${url}','displayCategoryNamesWin','${centerWinOptions(
            540,
            240,
          )}')">${value[0]}</a>`;
        },
      },
      {
        header: this.pDI18n('PLD_PRODUCT_GROUP'),
        name: 'groupType',
        minWidth: 110,
        align: 'center',
        ignored: true,
        formatter: ({ value }: any): any => {
          switch (value) {
            case 'DELIVERY':
              return this.pDI18n('PLD_GT_DELIVERY'); //
            case 'CONSIGNMENT':
              return this.pDI18n('PLD_GT_SERVICE'); //
            default:
              return '';
          }
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_DELIVERY_STATUS'),
        // name: 'deliveryYn',
        name: 'deliverable',
        minWidth: 110,
        align: 'center',
        ignored: true,
        formatter: ({ value }: any): string => {
          if (value === true) {
            return this.pDI18n('PLD_DELIVERY'); //
          }

          return this.pDI18n('PLD_NO_DELIVERY'); //
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_SHIPPING_CLASSIFICATION'),
        name: 'shippingAreaType',
        minWidth: 110,
        align: 'center',
        ignored: true,
        formatter: ({ value, row }: any): string => {
          if (!row.deliverable) {
            return '';
          }
          switch (value) {
            case 'PARTNER_SHIPPING_AREA':
              return this.pDI18n('PLD_PARTNER_DELIVERY'); //
            case 'MALL_SHIPPING_AREA':
              return this.pDI18n('PLD_SHOPPING_MALL_SHIPPING'); //
            default:
              return this.pDI18n('PLD_ALL'); //
          }
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_SHIPPING_COST_TYPE'),
        name: 'deliveryFeeType',
        minWidth: 120,
        align: 'center',
        ignored: true,
        formatter: ({ value, row }: any): string => {
          if (!row.deliverable) {
            return '';
          }
          switch (value) {
            case 'CONDITIONAL':
              // return `${this.pDI18n('PLD_CONDITIONALLY_FREE')}(${getCurrency(row.freeShippingConditionAmount, this.USMallNos.includes(row.mallNo))})`;
              return `${this.pDI18n('PLD_CONDITIONALLY_FREE')}(${getCurrency(row.freeShippingConditionAmount, true)})`;
            case 'FIXED_FEE':
              return this.pDI18n('PLD_PAID_FIXED_SHIPPING_FEE'); //
            default:
              return this.pDI18n('PLD_FREE'); //
              break;
          }
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLD_SHIPPING_FEE'),
        name: 'deliveryCharge',
        minWidth: 80,
        align: 'center',
        ignored: true,
        formatter: ({ value, row }: any): string => {
          if (!row.deliverable) {
            return '';
          }

          if (!value) {
            return '0';
          }

          // return getCurrency(value, this.USMallNos.includes(row.mallNo));
          return getCurrency(value);
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('PLM_BUNDLED_SHIPPING'),
        name: 'shippingCombinable',
        align: 'center',
        ignored: true,
        formatter({ value }) {
          return value ? 'Y' : 'N';
        },
        copyOptions: {
          useFormattedValue: true,
        },
      },
      {
        header: this.pDI18n('DELIVERY_DUE_DATE'), //
        name: 'usesDeliveryDueDate',
        align: 'center',
        ignored: true,
        formatter: ({ row }: any): string => {
          if (row.deliverable) {
            const url = `/product/popup/edit/${row.mallProductNo}/delivery-date`;
            return `<a href="javascript:onclick=window.open('${url}','deliveryDate','${centerWinOptions(
              1123,
              490,
            )}')">${row.usesDeliveryDueDate ? 'Y' : 'N'}</a>`;
          }
          return '-';
        },
        copyOptions: {
          customValue: columnValue => {
            return columnValue ? 'Y' : 'N';
          },
        },
      },
    ],
    options: {
      header: {
        height: 60,
      },
      columnOptions: {
        minWidth: 70,
        frozenCount: 5,
      },
      rowHeight: 30,
      virtualScrolling: true,
      displayRowCount: 20,
      minRowHeight: 35,
      isInitialRequest: false,
      useClientSort: false,
      heightResizable: true,
      pageOptions: {
        visiblePages: 10,
        perPage: 10,
        page: 1,
        totalCount: 0,
      },
    },
  };
  @State private onGnb!: boolean;
  @Watch('onGnb')
  onGnbChanged() {
    const grid = this.$refs.tuiGrid as Grid;
    if (grid) {
      grid.invoke('refreshLayout');
    }
  }
  created() {
    TuiGrid.setLanguage('ko', {
      display: {
        noData: this.pDI18n('ADDBULK_NO_DATA'),
      },
    });
    this.getPartnerDeliveryTemplates(this.stateAdmin.partnerNo);

    getProductsConfigurationsByAllMall().then((responses: any): void => {
      this.productDetailUrls = responses;
    });
    if (this.malls.length === 1) {
      this.product.mallNo = this.malls[0].mallNo;
      this.changedMall();
    }
  }
  changedMall() {
    this.$api
      .getContracts({
        params: {
          partnerNo: this.stateAdmin.partnerNo,
        },
      })
      .then(res => {
        const commissionRate = res.data.contents.find(content => content.mallNo === this.product.mallNo).commissionRate;
        if (commissionRate > 0) {
          this.product.productCommissionType = 'PARTNER';
          this.partner.commissionRate = commissionRate;
        } else {
          this.product.productCommissionType = 'PRODUCT';
          this.partner.commissionRate = commissionRate;
        }
      });
    this.$api
      .getAdminsServiceMerchandisers({
        params: {
          mallNo: String(this.product.mallNo),
        },
      })
      .then(res => {
        this.admins = res.data;
      });
    this.getShoppingMallDeliveryTemplates();
  }

  search(page: number) {
    const pageSize = this.gridProps.options.pageOptions.perPage;
    const params = {
      keywordInfo: {
        type: 'MALL_PRODUCT_NO',
        keywords: this.productNos.length ? this.productNos.map(productNo => String(productNo)) : undefined,
      },
      periodInfo: {
        type: 'REGISTER_DATE',
        period: {
          startYmdt: '1970-01-01 00:00:00',
          endYmdt: '2999-12-31 23:59:59',
        },
      },
      page: page,
      size: pageSize,
    };
    this.$api.postProductsSearch({ data: params } as any).then(({ data }): void => {
      this.products = data.contents;
      const grid = this.$refs.tuiGrid as Grid;
      const pagination = grid.invoke('getPagination') as any;
      if (pagination) {
        const pageState = {
          totalCount: data.totalCount,
          page,
          pageSize,
        };
        grid.invoke('resetData', this.products as any, { pageState });
      } else {
        grid.invoke('resetData', this.products as any);
      }
    });
  }
  mounted() {
    const grid = this.$refs.tuiGrid as Grid;
    const pagination = grid.invoke('getPagination');
    if (pagination) {
      grid.invoke('on', 'beforePageMove', (ev: any) => {
        this.search(ev.page);
        ev.stop();
      });
    }

    grid.invoke('on', 'mousedown', (ev: any) => {
      if (ev.targetType === 'columnHeader') {
        $('th[data-column-name="' + ev.columnName + '"]').removeClass('tui-grid-cell-selected');
      }
      let tagName = ev.nativeEvent.target.tagName;
      if (tagName === 'SELECT' || tagName === 'INPUT') {
        ev.stop();
      }
    });
  }
  get disableImageUpload() {
    if (
      !this.product.adminNo ||
      (this.product.productCommissionType === 'PRODUCT' && !this.product.commissionRate) ||
      !this.product.deliveryTemplateNo
    ) {
      return true;
    }
    return false;
  }
  public productDetailUrls: any[] = [];
  public getProductDetailUrl({ value, row }: any): string {
    const tempConfig = this.productDetailUrls.find(item => item.mallNo === row.mallNo);
    let url = '';

    if (tempConfig) {
      url = tempConfig.productDetailUrl.replace(/\${mallProductNo}/, value);
    }
    return `<a target="_blank" href="${url}">${value}</a>`;
  }
  private productNameOnChange(ev: any): void {
    if (this.products && this.products.length) {
      const currentRowData = { ...this.products[ev.rowKey] };
      if (currentRowData.saleSettingStatusType !== 'PROHIBITION_SALE') {
        const productName = ev.value;
        const params = {
          mallProductNos: currentRowData.mallProductNo.toString(),
        };
        const data = {
          productName,
        };
        this.$api.patchProducts({ params, data }).then((data): void => {
          if (this.gridModifyHandler(data)) {
            this.updateGrid(ev.rowKey, { productName });
          }
        });
      }
    }
  }
  public gridModifyHandler({ data: { totalCount, successNos, failures } }): boolean {
    if (totalCount) {
      if (successNos && successNos.length) {
        alert(this.pDI18n('PLD_IT_IS_CHANGED')); //
        return true;
      }

      if (failures && failures.length) {
        alert(failures[0].message);
      }
    }
    return false;
  }
  public updateGrid(rowKey: any, newData: any): void {
    const tuiGrid = this.$refs.tuiGrid as any;
    const rowData = tuiGrid.invoke('getRow', rowKey);
    const newRowData = Object.assign({}, { ...rowData, ...newData });
    tuiGrid.invoke('setRow', rowKey, newRowData);
  }
  getPartnerDeliveryTemplates(partnerNo: number) {
    if (partnerNo) {
      this.$api
        .getDeliveryTemplates({
          params: {
            partnerNo: partnerNo,
          },
        })
        .then(ret => {
          this.deliveryTemplates = ret.data;
          this.partnerDeliveryTemplates = ret.data;
        });
    }
  }
  uploadImage() {
    ncpPopup(
      `/product/popup/addBulkImage?mallNo=${this.product.mallNo}`,
      window.$t('PRODUCT_ADD_IMAGE_LOGIN'),
      894,
      563,
    );
  }
  fetchPlaceOrigin() {
    ncpPopup('/product/popup/searchPlaceOrigin', window.$t('PRODUCT_ADD_ORIGIN_SEARCH'), 808, 366);
  }
  fetchCertificate() {
    ncpPopup('/product/popup/searchCertificate', window.$t('PRODUCT_ADD_CERTIFICATION_SEARCH'), 810, 1010);
  }
  fetchDutyCategories() {
    ncpPopup('/product/popup/searchDutyCategory', window.$t('PRODUCT_ADD_INFO_NOTICE_SEARCH'), 545, 981);
  }
  fetchBrands() {
    if (this.checkMall()) {
      ncpPopup(
        `/product/popup/searchBrand?mallNo=${this.product.mallNo}`,
        window.$t('PRODUCT_ADD_BRAND_SEARCH'),
        800,
        571,
      );
    }
  }
  fetchCategory(type: string) {
    if (!this.checkMall()) {
      return;
    }

    ncpPopup(
      `/product/popup/searchCategory?mallNo=${this.product.mallNo}&type=${type}`,
      window.$t('PRODUCT_ADD_STANDARD_CATEGORY'),
      1262,
      315,
    );
  }
  getShoppingMallDeliveryTemplates() {
    this.$api
      .getMallsDeliveryPartnersByMallNo({
        params: {
          mallNo: this.product.mallNo,
        },
      })
      .then(ret => {
        this.shippingAreaPartnerNo = ret.data.partnerNo;
      })
      .then(() => {
        this.$api
          .getDeliveryTemplates({
            params: {
              partnerNo: this.shippingAreaPartnerNo,
            },
          })
          .then(ret => {
            this.shoppingMalldeliveryTemplates = ret.data;
          });
      });
  }

  private filterAdmins(e: Event) {
    if (this.checkMall()) {
      const value = (e.target as HTMLInputElement).value;
      this.admin.adminName = value;
      if (value) {
        this.displayAdmins = this.admins.filter(item => {
          return item.name.indexOf(value) > -1;
        });
        if (!this.displayAdmins.length) {
          this.displayAdmins.push({ adminNo: 0, name: this.$t('PRODUCT_ADD_SEARCH_NONE') });
        }
      } else {
        this.displayAdmins = [];
        this.displayAdmins.push({ adminNo: 0, name: this.$t('PRODUCT_ADD_SEARCH_NONE') });
      }
    } else {
      this.admin.adminName = '';
    }
  }
  private setAdmin(admin: Mds) {
    if (admin.adminNo !== 0) {
      this.product.adminNo = admin.adminNo;
      this.admin.adminName = admin.name;

      this.displayAdmins = [];
    }
  }
  private resetAdmin() {
    this.product.adminNo = 0;
    this.admin.adminName = '';
    this.displayAdmins = [];
  }
  sampleDownload() {
    const params = {
      fileName: 'addBulk_product_sample_20231004.xlsx',
      container: 'excel-sample',
    };
    this.$api.getStorage({ params, responseType: 'blob' }).then(res => {
      const myBlob = new window.Blob([res.data], { type: 'blob' });
      const qrUrl = window.URL.createObjectURL(myBlob);
      const a = document.createElement('a');
      const event = new MouseEvent('click');
      a.download = 'addBulk_product_sample_20231004.xlsx';
      a.href = qrUrl;
      a.dispatchEvent(event);
      window.URL.revokeObjectURL(qrUrl);
    });
  }
  addTemplate() {
    let title = this.$t('PRODUCT_ADD_DELIVERY_TEMPLATE_POP_TITLE');
    ncpPopup(`/deliveryTemplate/addForm?partnerNo=${this.stateAdmin.partnerNo}`, title, 1000, 300);
  }
  @Watch('product.productCommissionType')
  onProductCommissionTypeChanged(newVal: string) {
    if (newVal === 'CATEGORY') {
      this.product.commissionRate = '';
    }
    if (newVal === 'PRODUCT') {
      this.product.commissionRate = '';
    }
    if (newVal === 'PARTNER') {
      this.product.commissionRate = this.partner.commissionRate;
    }
  }
  @Watch('deliveryTemplates')
  onDeliveryTemplatesChanged() {
    if (this.deliveryTemplates.length) {
      const currentTemplate = this.deliveryTemplates.find(item => this.product.deliveryTemplateNo === item.templateNo);
      const defaultTemplate = this.deliveryTemplates.find(item => item.default);
      if (currentTemplate) {
        this.product.deliveryTemplateNo = currentTemplate.templateNo;
      } else {
        this.product.deliveryTemplateNo = defaultTemplate
          ? defaultTemplate.templateNo
          : this.deliveryTemplates[0].templateNo;
      }
    } else {
      this.product.deliveryTemplateNo = 0;
    }
  }
  @Watch('product.shippingAreaType')
  onShippingAreaTypeChanged(newVal: any) {
    if (newVal === 'MALL_SHIPPING_AREA') {
      if (this.checkMall()) {
        this.deliveryTemplates = this.shoppingMalldeliveryTemplates;
        this.shoppingMalldeliveryTemplates.forEach(template => {
          if (template.default) {
            this.product.deliveryTemplateNo = template.templateNo;
          }
        });
      } else {
        this.$nextTick(() => {
          this.product.shippingAreaType = 'PARTNER_SHIPPING_AREA';
          this.$forceUpdate();
        });
      }
    } else {
      this.deliveryTemplates = this.partnerDeliveryTemplates;
    }
  }
  @Watch('stateDeliveryTemplateNo')
  onStateDeliveryTemplateNoChanged(newVal: number) {
    if (newVal) {
      this.setNewDeliveryTemplateNo(newVal);
    }
  }
  setNewDeliveryTemplateNo(deliveryTemplateNo: number) {
    this.product.deliveryTemplateNo = deliveryTemplateNo;
    this.getPartnerDeliveryTemplates(this.stateAdmin.partnerNo);
  }
  onClickUploadExcelBtn() {
    $('#excelFile').click();
  }

  private validateExcelFile() {
    if ($('#excelFile').val() === '') {
      alert(this.pDI18n('PLEASE_SELECT'));

      return false;
    }

    if (!this.product.mallNo) {
      alert(this.$t('COMMON_ERR_MALLNO_NULL'));

      return false;
    }

    if (!this.product.adminNo) {
      alert(this.pDI18n('SELECT_ADMIN'));

      return false;
    }

    return true;
  }

  onChangeExcelFile() {
    if (!this.validateExcelFile()) {
      $('#excelFile').val('');

      return;
    }

    const formData = new FormData();
    formData.append('excelFile', ($('#excelFile')[0] as HTMLInputElement).files[0]);
    formData.append('mallNo', String(this.product.mallNo));
    formData.append('productCommissionType', this.product.productCommissionType);
    formData.append('commissionRate', this.product.commissionRate || 0);
    formData.append('shippingAreaType', this.product.shippingAreaType);
    formData.append('deliveryTemplateNo', this.product.deliveryTemplateNo);
    formData.append('uploadedImages', this.externalUrlYn === 'Y' ? '' : this.uploadedImages.toString());
    formData.append('adminNo', this.product.adminNo);
    formData.append('externalUrlYn', this.externalUrlYn);
    formData.append('classType', 'DEFAULT');
    $('#excelFile').val('');
    this.$api
      .postProductsExcel({ data: formData })
      .then(res => {
        this.layerPop = true;
        this.uploadedResult.failCount = res.data.failCount;
        this.uploadedResult.seq = res.data.seq;
        this.uploadedResult.successCount = res.data.successCount;
        if (res.data.successMallProductNos.length) {
          this.productNos = [...this.productNos, ...res.data.successMallProductNos];
          this.search(this.gridProps.options.pageOptions.page);
        }
      })
      .catch(err => {
        if (err.data) {
          alert(err.data.message);
          throw err;
        }
      });
  }
  downloadFaildExcel() {
    if (this.uploadedResult.failCount === 0) {
      alert(this.pDI18n('LOGIN_NO_FAIL'));
      return;
    }
    const fileName = `Errors_Product_ExcelForm_${getToday()}`;
    const params = { seq: this.uploadedResult.seq, mallNo: Number(this.product.mallNo) };
    this.$api
      .getProductsExcelFailResults({ params, responseType: 'arraybuffer' })
      .then(res => {
        const blob = new window.Blob([res.data], { type: 'application/octet-stream' });
        saveAs(blob, fileName + '.xlsx');
      })
      .catch(error => {});
  }
  private keyUpCommissionRate() {
    if (this.malls.length !== 1) {
      if (this.product.productCommissionType == 'PRODUCT' && !this.product.mallNo) {
        alert(window.$t('PRODUCT_ADD_EMPTY_MALLNO'));
        return false;
      }
    }
  }
  private adminNameViews(admin) {
    const input = this.admin.adminName;
    const reg = new RegExp(input, 'gi');
    const resultName = admin.name.replace(reg, function(txt: string) {
      return `<span>${txt}</span>`;
    });
    const result = admin.id ? `${resultName}(${admin.id})` : resultName;
    return result;
  }
  private onlyNumber(e) {
    if (this.checkMall()) {
      let value = e.target.value;

      if (/[^0-9.]+/g.test(value)) {
        this.errorCommissionRate = true;
      } else {
        this.errorCommissionRate = false;
      }

      if (!value) {
        this.errorCommissionRate = false;
      }

      value = value.replace(/[^0-9.]+/g, '');

      if (value[0] === '.') {
        value = '0' + value;
      }

      const arr = value.split('.');
      if (arr[1]) {
        arr[1] = arr[1].slice(0, 1);
      }
      value = arr.join('.');

      const number = Number(value);

      if (!isNaN(number)) {
        if (number < 0) {
          value = '0';
          this.errorCommissionRate = false;
        }

        if (number > 99.9) {
          value = '99.9';
          this.errorCommissionRate = false;
        }
      }

      this.product.commissionRate = value;
    } else {
      this.product.commissionRate = '';
    }
  }
  private blurOnlyNumber() {
    if (this.product.commissionRate && this.product.commissionRate[this.product.commissionRate.length - 1] === '.') {
      this.product.commissionRate = this.product.commissionRate.slice(0, this.product.commissionRate.length - 1);
    }

    this.errorCommissionRate = false;
  }
  beforeDestroy() {
    TuiGrid.setLanguage('ko', {
      display: {
        noData: window.$t('COMMON_RESULT_NONE'),
      },
    });
  }
  private checkMall(): boolean {
    if (!this.product.mallNo) {
      alert(this.$t('PRODUCT_ADD_REQUIRE_MALL'));
      $('#mallNo').focus();
      return false;
    }
    return true;
  }
}
